import { Component } from 'react';
import { get } from 'axios';
import { message } from 'antd';
import produce from 'immer';

class FetchList extends Component {
  static defaultProps = {
    api: '',
    autoFetch: false,
    perPage: 10,
    headers: {},
    params: {}
  }

  state = {
    data: [],
    page: 0,
    lastPage: 1,
    total: 0,
    loading: false,
  }

  componentDidMount() {
    if (this.props.autoFetch) {
      this.getPageData(1);
    }
  }

  render() {
    const {
      data,
      page,
      total,
      loading,
    } = this.state;
    const { perPage } = this.props;

    return this.props.children({
      data,
      page,
      total,
      loading,
      perPage,
      getPageData: this.getPageData,
    });
  }

  getPageData = async (page) => {
    await this.getData(page);
  }

  getNextPage = async () => {
    const { page, lastPage } = this.props;
    if (page === lastPage) {
      message.info('没有更多数据了!');
    }

    try {
      await this.getData(page + 1);
    } catch (err) {
      message.error(err.message);
      throw err;
    }
  }

  getData = async (page) => {
    const { api, params, headers, perPage } = this.props;

    try {
      this.setState({
        loading: true
      });
      const { data } = await get(api, {
        params: {
          page,
          per_page: perPage,
          ...params
        },
        headers: {
          ...headers,
        }
      });
      if (data.error_code !== 0) {
        message.error(data.message);
      } else {
        this.setState(produce(draft => {
          draft.loading = false;
          draft.data = data.data.data;
          draft.total = data.data.total;
          draft.page = data.data.current_page;
          draft.lastPage = data.data.last_page;
        }));
      }
    } catch (err) {
      this.setState({
        loading: false,
      })
      throw err;
    }
  }
}

export default FetchList;
